/** `tel:` link for a phone number as merchants type it ("509 023 382", "+48 42-718-95-57"). */
export function telHref(phone: string): string {
    return `tel:${phone.replace(/[^\d+]/g, '')}`;
}

/** A phone field may hold several numbers ("509 023 382, 42 718 95 57") — one link each. */
export function splitPhones(value: string | null | undefined): string[] {
    return (value || '').split(/[,;|]/).map(p => p.trim()).filter(Boolean);
}
